<template>
    <div>
        <mu-avatar icon="alarm"></mu-avatar>
        <label>时间选择器</label>
    </div>
</template>
<script>
export default {
    name: 'timePicker'
}
</script>



// WEBPACK FOOTER //
// timePicker.vue?5b1829b1